import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class StaffsArquivosTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      name: '',
      archive: '',
      dados: [],
    };

    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionarArquivo = this.adicionarArquivo.bind(this);
    this.botaoDownloadArquivo = this.botaoDownloadArquivo.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }

  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.file)) {
      this.setState({dados: newProps.file});
    }
  }

  adicionarArquivo(event) {
    event.preventDefault();
    var data = new FormData();
    var imagedata = document.querySelector('input[type="file"]').files[0];
    data.append("name", this.state.name);
    data.append("imagem", imagedata);
    data.append("staff_id", this.props.staff_id);
    var header = this.refs.request_api.header();
    var self = this;
    this.props.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/aluno/arquivo', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var dados_temp = self.state.dados;
            dados_temp.push(responseJson.data);
            self.setState({dados: dados_temp});
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
        console.error(error);
      });
    });   
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var staff_archive_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse arquivo?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aluno/arquivo/' + staff_archive_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            self.deletarLinha(staff_archive_id);
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(staff_archive_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == staff_archive_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  botaoDownloadArquivo (cell, row) {
    var dados = this.state.dados;
    var status = '';
    var arquivo = '';
    var nome = '';
    dados.map(function(dado, index){
      if (dado.id == cell) {
        arquivo = dado.archive;
        nome = dado.name;
      }
    });
    return (
      <a target="_blank" href={config.get('cdn') + '/file_digital/' + arquivo}> {nome}</a>
    );
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Adicionar arquivos</h3>
  <hr/>
    <form onSubmit={this.adicionarArquivo}> 
      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label>Nome do arquivo:</label>
            <input type="text" name="name" className="form-control" placeholder="Nome do arquivo" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-group">
            <label>Arquivo:</label>
            <input type="text" type="file" name="archive" className="form-control" placeholder="Arquivo" value={this.state.archive} onChange={this.handleChange.bind(this, 'archive')} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-plus"></i> Adicionar arquivo</button>
          </div>
        </div>
      </div>
    </form>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há arquivos cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataFormat={this.botaoDownloadArquivo} dataField="id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome do arquivo</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default StaffsArquivosTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffsArquivosTab.js